import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Trash as r } from "@pelando/fontawesome/icons";
import { DeletedMessageWrapper as n, DeletedIcon as i } from "./style.js";
import { useTranslation as m } from "../../../../hooks/useTranslation/index.js";
function p() {
  const { t: o } = m("common");
  return /* @__PURE__ */ e("div", { children: /* @__PURE__ */ t(n, { children: [
    /* @__PURE__ */ e(i, { icon: r }),
    "[",
    o("deleted-content"),
    "]"
  ] }) });
}
export {
  p as DeletedContent
};
